import { IDropdownOption, TOptionValues } from '../../../types/dropdown';

export const useSelectOption = (
  handler: (name: string, selectedOptions: TOptionValues) => void,
  name: string,
  selectedOptions: TOptionValues = [],
) => {
  const onOptionSelect = (state: boolean, item: IDropdownOption) => {
    const updateSelectedList: TOptionValues = selectedOptions;

    if (state) {
      updateSelectedList.push(item.value);
    } else {
      const filterIndex = updateSelectedList.findIndex(option => option === item.value);

      updateSelectedList.splice(filterIndex, 1);
    }

    handler(name, updateSelectedList);
  };

  const checkIsSelected = (item: IDropdownOption) => {
    const optionIndex = selectedOptions.findIndex(option => option === item.value);

    return optionIndex > -1;
  };

  return { checkIsSelected, onOptionSelect };
};
